module.exports = __webpack_public_path__ + "static/img/ruweiEn.47eb408.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ruweiEn.png
// module id = W6qD
// module chunks = 1